import { render, staticRenderFns } from "./ForgotPasswordDialog.vue?vue&type=template&id=2d1bd956&scoped=true"
import script from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordDialog.vue?vue&type=style&index=0&id=2d1bd956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1bd956",
  null
  
)

export default component.exports